import { UserType } from '@/core/domain/yCarsAuth/User/User.types';

export enum YCarsStatus {
  inactive = 'INACTIVE',
  pending = 'PENDING',
  active = 'ACTIVE',
  alreadyRegistred = 'ALREADY_REGISTERED',
}

export interface UserYCars {
  name?: string;
  cpfCnpj?: string;
  photoUrl?: string;
  id: number;
  type: UserType;
  rentalCompany: boolean;
}
